import PropTypes from 'prop-types';

import { useIsUserAllowedByPermission } from '../hooks';

export function HasPermission({ children, permission = [] }) {
  const isAllowed = useIsUserAllowedByPermission(permission);
  if (isAllowed) {
    return children;
  }
  return null;
}

export default HasPermission;

HasPermission.propTypes = {
  children: PropTypes.node.isRequired,
  permission: PropTypes.arrayOf(PropTypes.string)
};
